import React from 'react';

import { CSSObject } from 'styled-components';
import { ListStyled, TitleStyled } from './list.styled';
import Box from '../Box';
import SvgIcon from '../SvgIcon';
import { Size } from '../SvgIcon/types';

interface ListProps {
  title?: string;
  sx?: CSSObject;
  icon?: React.ReactNode;
  iconSize?: keyof typeof Size;
  alignItems?: string;
  titleIcon?: React.ReactNode;
  children?: React.ReactNode | React.ReactNode[];
}

const List = ({
  children,
  title,
  icon,
  iconSize,
  titleIcon,
  alignItems,
  sx,
}: ListProps) => {
  let childrenElement = children;

  if (icon || iconSize || alignItems) {
    childrenElement = (
      <>
        {React.Children.map(children, (child: React.ReactElement) => {
          return React.cloneElement(child, {
            icon,
            iconSize,
            alignItems,
            ...child.props,
          });
        })}
      </>
    );
  }

  return (
    <>
      {title ? (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {titleIcon ? <SvgIcon icon={titleIcon} size='large' /> : null}
          <TitleStyled>{title}</TitleStyled>
        </Box>
      ) : null}
      <ListStyled sx={sx}>{childrenElement}</ListStyled>
    </>
  );
};

export default List;
